import { render, staticRenderFns } from "./FilterShops.vue?vue&type=template&id=0c6657ec&scoped=true&"
import script from "./FilterShops.vue?vue&type=script&lang=js&"
export * from "./FilterShops.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6657ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dmitrichiriuhin/code/pesoto-node/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c6657ec')) {
      api.createRecord('0c6657ec', component.options)
    } else {
      api.reload('0c6657ec', component.options)
    }
    module.hot.accept("./FilterShops.vue?vue&type=template&id=0c6657ec&scoped=true&", function () {
      api.rerender('0c6657ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/FilterShops.vue"
export default component.exports